import { useState } from "react"
import type { FormEvent } from "react"
import { useAsyncAction } from "../hooks/index.ts"
import { useI18n } from "../i18n/index.tsx"
import { useSession } from "../auth/SessionProvider.tsx"
import { Button, Card, ErrorNote, Field, Input } from "../ui/index.ts"

export function LoginPage() {
  const { t, locale, setLocale } = useI18n()
  const { login } = useSession()
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const { busy, error, run } = useAsyncAction()

  async function submit(event: FormEvent) {
    event.preventDefault()
    await run(() => login(email, password))
  }

  return (
    <div className="login">
      <div className="login__box">
        <div className="login__brand">
          <img className="login__logo" src="/ban_open.webp" alt="COOLTRACK" />
          <h1 className="login__title">{t("app.title")}</h1>
          <p className="login__subtitle">{t("login.subtitle")}</p>
        </div>

        <Card>
          <form onSubmit={(event) => void submit(event)}>
            <ErrorNote error={error} />

            <Field label={t("login.id")} htmlFor="login-id" required>
              <Input
                id="login-id"
                type="text"
                value={email}
                autoComplete="username"
                autoFocus
                required
                onChange={(event) => setEmail(event.target.value)}
              />
            </Field>

            <Field label={t("login.password")} htmlFor="login-pw" required>
              <Input
                id="login-pw"
                type="password"
                value={password}
                autoComplete="current-password"
                required
                onChange={(event) => setPassword(event.target.value)}
              />
            </Field>

            <Button type="submit" variant="primary" block loading={busy}>
              {busy ? t("login.submitting") : t("login.submit")}
            </Button>
          </form>
        </Card>

        <div className="login__locale">
          <Button variant="link" onClick={() => setLocale(locale === "ko" ? "ja" : "ko")}>
            {locale === "ko" ? "日本語" : "한국어"}
          </Button>
        </div>
      </div>
    </div>
  )
}
